import { render, staticRenderFns } from "./LayoutV2.vue?vue&type=template&id=43574dfc&scoped=true"
import script from "./LayoutV2.vue?vue&type=script&lang=js"
export * from "./LayoutV2.vue?vue&type=script&lang=js"
import style0 from "./LayoutV2.vue?vue&type=style&index=0&id=43574dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43574dfc",
  null
  
)

export default component.exports